<div class="row">
  <div class="col-md-10 col-10">
    <h3 class="mb-0" mat-dialog-title>{{ 'ReviewRental' | translate  }}</h3>
  </div>
  <div class="col-md-2 col-2 p-0">
    <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()">
      <fa-icon [icon]="faTimesCircle"></fa-icon>
    </button>
  </div>
</div>

<mat-dialog-content>

  <!--Add Mode-->
  <div *ngIf="evaluationLogsMasters==null">

    <div class="vehicle-review-card mb-3">


      <!-- vehicle -->
      <div class="row m-0">
        <div class="col-md-3 mt-2">
          <div class="car-image">
            <img class="img-fluid" [src]="attachmentService
            .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)" [alt]="vehicle.vehicleName">
          </div>
        </div>
        <div class="col-md-6  mt-2">
          <div class="d-flex">
            <div class="vehicle-name mr-auto">
              {{vehicle.vehicleName}}
            </div>
            <div class="vehicle-top-list  d-flex align-items-top">
              <div class="vehicle-class">
                {{vehicle.vehicleClass}}
              </div>
            </div>
          </div>


          <div class="vehicle-features">
            <div class="row mt-2">
              <!-- vehicle Gear Type-->
              <div class="col-md-6   mb-1  col-6 d-flex  align-items-top">
                <span>
                  <!-- <mat-icon ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" matTooltipPosition="bottom"
                    class="custom-icon mr-1" svgIcon="car-gear"></mat-icon> -->
                    <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleGearType}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Condition Unit -->
              <div class="col-md-6 mb-1  col-6 d-flex align-items-top">
                <span>
                  <mat-icon placement="bottom" ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave"
                  class="fa-s mr-1">ac_unit</mat-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Petrol Type -->
              <div class="col-md-6  mb-1  col-6  d-flex align-items-top">
                <span>
                  <fa-icon class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                    [icon]="faGasPump"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehiclePetrolType}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Passengers Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <fa-icon class="mr-1" ngbPopover="{{ 'Passengers' | translate }}" triggers="mouseenter:mouseleave"
                    [icon]="faUser"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehiclePassengersNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Doors Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <!-- <mat-icon ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" class="custom-icon mr-1"
                    svgIcon="car-door"></mat-icon> -->
                    <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleDoorsNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Storage -->
              <div class="col-md-6  mb-1   col-6 d-flex align-items-top">
                <span>
                  <mat-icon ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                    class="fa-s luggage mr-1">luggage</mat-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleStorage}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <fa-icon placement="bottom" ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave"
                                class="mr-1 vehicleNumber" [icon]="faCar"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.plateNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Odometer -->
              <div class="col-md-6  mb-1 col-6 d-flex align-items-top">
                <span>
                  <fa-icon placement="bottom" ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave"
                  class="mr-1 faRoad" [icon]="faRoad"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleOdometer}}</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- vehicle Location -->
            <div class="row mb-2 ">
              <div class="col-md-12 location-line d-flex align-items-top">
                <fa-icon ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-3 pr-3 rank-review-bg col-12 align-items-center">

          <div *ngIf="true">
            <div class="rank-review-text" *ngIf="evaluationDomainTemplates.average==null">0.00</div>
            <div class="rank-review-text" *ngIf="evaluationDomainTemplates.average!=null">{{evaluationDomainTemplates.average  | number : '1.2-2'}}</div>
            <div class="rank-review-text" *ngIf="evaluationDomainTemplates.resourceName!=null">{{evaluationDomainTemplates.resourceName}}</div>
            <div class="rank-review-text" *ngIf="evaluationDomainTemplates.resourceName==null">{{'NoRank' | translate}}</div>
          </div>


        </div>
      </div>
      <!-- vehicle -->
    </div>



    <ng-container *ngIf="evaluationDomainTemplates!=null">
      <h1 >{{evaluationDomainTemplates.avarage}}</h1>
      <div class="row mt-3">
        <ng-container  *ngFor="let domain of evaluationDomainTemplates.evaluationDomains">
          <div *ngFor="let review of domain.evaluationDomainSkills" class="col-md-6">
            <div class="slideContainer">
              <div class="d-flex">
                <div class="mr-auto slideCriteria">{{review.description}}</div>
                <div class="slideValue badge badge-pill badge-primary">{{review.average}}</div>
              </div>
              <mat-slider
              class="mb-2"
               min="1"
               max="10"
               [value]="review.average"
               #mySlider
               (input)="sliderOnChange(review,domain,mySlider.value)"

              >
            </mat-slider>
            <!-- (slideend)="sliderOnChange(review,evaluationDomainSkills,mySlider.value)"
            (pointerup)="sliderOnChange(review,evaluationDomainSkills,mySlider.value)" -->
            </div>
          </div>

        </ng-container>
        <div class="col-md-12 mb-3">
          <textarea placeholder="{{ 'writeyourreview' | translate }}" class="form-control review-textbox" cdkTextareaAutosize
          [(ngModel)]='evaluatorComment' #autosize="cdkTextareaAutosize" rows="2" cdkAutosizeMinRows="2"></textarea>
          <div *ngIf="errorReviewMsg">
            <div >
              <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <button (click)='addEvaluation()' class="btn default-btn mr-3" mat-button>{{ 'Save' | translate }}</button>
          <button (click)='close()' class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
        </div>
      </div>

  </ng-container>
<!--
    <div class="row mt-3">
      <div *ngFor="let review of reviews" class="col-md-6">
        <div class="slideContainer">
          <div class="d-flex">
            <div class="mr-auto slideCriteria">{{review.criteria}}</div>
            <div class="slideValue">{{review.value}}</div>
          </div>
          <mat-slider class="mb-2" min="1" max="7" value="3"></mat-slider>
        </div>
      </div>

    </div> -->

  </div>

  <!--View Mode-->
  <div *ngIf="evaluationLogsMasters!=null">
    <div class="vehicle-review-card mb-3">
      <!-- vehicle -->
      <div class="row m-0">
        <div class="col-md-3 mt-2">
          <div class="car-image">
            <img class="img-fluid" [src]="attachmentService
            .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)" [alt]="vehicle.vehicleName">
          </div>
        </div>
        <div class="col-md-6  mt-2">
          <div class="d-flex">
            <div class="vehicle-name mr-auto">
              {{vehicle.vehicleName}}
            </div>
            <div class="vehicle-top-list  d-flex align-items-top">
              <div class="vehicle-class">
                {{vehicle.vehicleClass}}
              </div>
            </div>
          </div>



          <div class="vehicle-features">
            <div class="row mt-2">
              <!-- vehicle Gear Type-->
              <div class="col-md-6   mb-1  col-6 d-flex  align-items-top">
                <span>
                  <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleGearType}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Condition Unit -->
              <div class="col-md-6 mb-1  col-6 d-flex align-items-top">
                <span>
                  <mat-icon placement="bottom" ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave"
                  class="fa-s mr-1">ac_unit</mat-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Petrol Type -->
              <div class="col-md-6  mb-1  col-6  d-flex align-items-top">
                <span>
                  <fa-icon class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                    [icon]="faGasPump"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehiclePetrolType}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Passengers Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <fa-icon class="mr-1" matTooltip="{{ 'Passengers' | translate }}" matTooltipPosition="bottom"
                    [icon]="faUser"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehiclePassengersNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Doors Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleDoorsNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Storage -->
              <div class="col-md-6  mb-1   col-6 d-flex align-items-top">
                <span>
                  <mat-icon matTooltip="{{ 'Luggage' | translate }}" matTooltipPosition="bottom"
                    class="fa-s luggage mr-1">luggage</mat-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleStorage}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Number -->
              <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
                <span>
                  <fa-icon placement="bottom" ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave"
                                class="mr-1 vehicleNumber" [icon]="faCar"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.plateNumber}}</li>
                  </ul>
                </div>
              </div>

              <!-- vehicle Odometer -->
              <div class="col-md-6  mb-1 col-6 d-flex align-items-top">
                <span>
                  <fa-icon placement="bottom" ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave"
                                class="mr-1 faRoad" [icon]="faRoad"></fa-icon>
                </span>
                <div>
                  <ul class="vehicle-inner-list">
                    <li>{{vehicle.vehicleOdometer}}</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- vehicle Location -->
            <div class="row mb-2 ">
              <div class="col-md-12 location-line d-flex align-items-top">
                <fa-icon ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-3 pr-3 rank-review-bg col-12 align-items-center">
          <div class="rank-review-text">{{evaluationLogsMasters.average}}</div>
          <div class="rank-review-text">{{evaluationLogsMasters.resourceName}}</div>
        </div>
      </div>

      <!-- vehicle -->
    </div>

    <div class="row mt-3">
      <div *ngFor="let review of evaluationLogsMasters.evaluationLogsDetails" class="col-md-6">
        <div class="slideContainer">
          <div class="d-flex">
            <div class="mr-auto slideCriteria">{{review.description}}</div>
            <!-- <div class="slideValue badge badge-pill badge-primary">{{review.evaluatorAssessmentValue}}</div> -->
          </div>
          <mat-slider disabled class="mb-2" min="0" max="10" [value]="review.evaluatorAssessmentValue"></mat-slider>
        </div>
      </div>


      <div class="col-md-12 mt-3">
        <div class="row m-0">
          <div class="col-md-2 text-center">
            <img  width="60px"
            [src]="attachmentService.getImageLink(customer.customerID,attachmentScopesEnum.Customer, attachmentTypeEnum.CustomerIndividualImage)"
            ><div class="reviewName">{{customer.defaultName}}</div></div>
          <div class="col-md-10">
            <div class="reviewBox">
              <div class="d-flex">
                <div class="reviewComment mt-2 mr-auto">{{evaluationLogsMasters.evaluatorComment}}</div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>





</mat-dialog-content>
